import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { CooperationInfoList } from '../../../external/LinkedDataApi';
export interface LinkedDataResultTableProps {
  data: CooperationInfoList[];
  renderTableItem: (item: CooperationInfoList, index: number) => ReactNode;
  tableHeader: ReactNode;
  className?: string;
  style?: { [key: string]: any };
  scrollRefTable: React.RefObject<HTMLDivElement>;
}

const LinkedDataResultTable = ({ data, renderTableItem, tableHeader, className, style, scrollRefTable }: LinkedDataResultTableProps) => {
  return (
    <div className={classNames('linked-data-result-table', className)} style={style} ref={scrollRefTable}>
      {data.length ? (
        <table>
          {tableHeader}
          <tbody data-testid='linked-data-result-table-body'>{data.map(renderTableItem)}</tbody>
        </table>
      ) : (
        <div data-testid-e2e='linked-data-result-table__td-no-result' className='linked-data-result-table__td is-no-result'>
          登録連携情報が見つかりません。
        </div>
      )}
    </div>
  );
};

/**
 * <thead>
 * LinkedDataResultTable.THead
 */
const TableHead: React.FC<React.HTMLProps<HTMLTableSectionElement>> = ({ className, children, ...props }) => (
  <thead {...props}>
    <tr className={classNames('linked-data-result-table__header', className)}>{children}</tr>
  </thead>
);

/**
 * <tr>
 * LinkedDataResultTable.Tr
 */

const TableItemRow: React.FC<React.HTMLProps<HTMLTableRowElement>> = ({ className, children, ...props }) => {
  const classes = classNames('linked-data-result-table__row', className);
  return (
    <>
      <tr className={classes} {...props}>
        {children}
      </tr>
      <tr className='linked-data-result-table__row-space'></tr>
    </>
  );
};

/**
 * <th>
 * Table.Th
 */

const TableTh: React.FC<React.HTMLProps<HTMLTableHeaderCellElement>> = ({ className, children, ...props }) => {
  const classes = classNames('linked-data-result-table__th', className);
  return (
    <th className={classes} {...props}>
      {children}
    </th>
  );
};

/**
 * <td>
 * LinkedDataResultTable.Td
 */

const TableTd: React.FC<React.HTMLProps<HTMLTableDataCellElement>> = ({ className, children, ...props }) => {
  const classes = classNames('linked-data-result-table__td', className);
  return (
    <td className={classes} {...props}>
      {children}
    </td>
  );
};

LinkedDataResultTable.Header = TableHead;
LinkedDataResultTable.Item = TableItemRow;
LinkedDataResultTable.Th = TableTh;
LinkedDataResultTable.Td = TableTd;

export default LinkedDataResultTable;
